/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AttributeValueForBoolean extends models.AttributeValueBase {
    constructor() {
        super();
        this.setDiscriminator("AttributeValueForBoolean");
    }

    getFixupPrototypeFunction() { return AttributeValueForBoolean.fixupPrototype; }

    static newInstance(model: Partial<AttributeValueForBoolean>): AttributeValueForBoolean {
        let obj = Object.assign(new AttributeValueForBoolean(), model);
        AttributeValueForBoolean.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AttributeValueForBoolean>): AttributeValueForBoolean {
        if (!model) return null;
        return AttributeValueForBoolean.newInstance(<AttributeValueForBoolean> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AttributeValueForBoolean) {
        if (!obj) return;

        models.AttributeValueForBoolean.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AttributeValueForBoolean): boolean {
        if (models.AttributeValueBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AttributeValueForBoolean.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Value for the Attribute
     */
    value: boolean;

}
